import { ChangeDetectionStrategy, Component, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { ComparatorConfig } from './_config/comparator.model';

@Component({
  selector: 'plyca-ui-comparator',
  templateUrl: './comparator.component.html',
  styleUrl: './comparator.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PlycaUiComparatorComponent {
  public config: InputSignal<ComparatorConfig> = input.required<ComparatorConfig>();
}
